function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    height: 32px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import Text from "../../Typography/Text";
import { mediaSmDown } from "../../../theme/helpers/media";
import colors from "../../../colors/index";
export var ProductName = styled(Text).attrs(function (_ref) {
  var _theme$name;

  var theme = _ref.theme,
      children = _ref.children;
  return {
    fontWeight: theme === null || theme === void 0 ? void 0 : (_theme$name = theme.name) === null || _theme$name === void 0 ? void 0 : _theme$name.fontWeight,
    title: children
  };
}).withConfig({
  displayName: "Name__ProductName",
  componentId: "sc-7ypi2e-0"
})(["overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;height:38px;", ";", ""], function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["line-height:16px !important;font-size:14px !important;font-weight:normal;color:", ";height:32px;"], colors.dark300);
  }
}, mediaSmDown(_templateObject()));